import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navbar from './components/site/Navbar';
import Footer from './components/site/Footer';
import ScrollToTop from './components/site/ScrollToTop';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Blog from './pages/Blog';
import BlogDetail from './pages/BlogDetail';
import Contact from './pages/Contact';
import Projects from './pages/Projects';
import ProjectDetail from './pages/ProjectDetail';
import Media from './pages/Media';
import Investors from './pages/Investors';
import Careers from './pages/Careers';
import FAQ from './pages/FAQ';
import Legal, { disclaimerBody, privacyBody, termsBody, refundBody } from './pages/Legal';
import Admin from './pages/Admin';
import { Toaster } from './components/ui/toaster';
import ServiceDetail from './pages/ServiceDetail';
import WelcomeOverlay from './components/site/WelcomeOverlay';
import StickyMobileBar from './components/site/StickyMobileBar';


function App() {
  return (
    <div className="App bg-[#0f1a14] text-white min-h-screen">
      <BrowserRouter>
        <ScrollToTop />
        <WelcomeOverlay />
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/about-us" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/services/:slug" element={<ServiceDetail />} />
            {/* <Route path="/projects" element={<Projects />} /> */}
            <Route path="/projects/:id" element={<ProjectDetail />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogDetail />} />
            <Route path="/media" element={<Media />} />
            <Route path="/investors" element={<Investors />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/faqs" element={<FAQ />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/contact-us" element={<Contact />} />
            <Route path="/disclaimer" element={<Legal eyebrow="Legal" title="Disclaimer" body={disclaimerBody} />} />
            <Route path="/privacy-policy" element={<Legal eyebrow="Legal" title="Privacy Policy" body={privacyBody} />} />
            <Route path="/terms-and-conditions" element={<Legal eyebrow="Legal" title="Terms & Conditions" body={termsBody} />} />
            <Route path="/refund-policy" element={<Legal eyebrow="Legal" title="Refund Policy" body={refundBody} />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </main>
        <Footer />
        <StickyMobileBar />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
